import React from "react"
import clsx from "clsx"
import { AppLink } from "@ecom/ui/components/AppLink"
import * as styles from "./moreFiles.module.scss"
import { SvgFile } from "../../img/SvgFile"
import { SvgOpen } from "../../img/SvgOpen"

export const MoreFiles = () => (
  <AppLink
    href="https://scb.ru/pages/vse-aktsii-karti-halva-"
    target="_blank"
    rel="noreferrer"
    className={styles.documentWrapper}
  >
    <SvgFile className={clsx(styles.documentIcon)} />
    <p className={styles.documentText}>Все акции карты “Халва“</p>
    <SvgOpen className={clsx(styles.documentIcon, styles.documentOpen)} />
  </AppLink>
)
